// ONE place for the legal/contact details shown on the public site. Meta Business verification compares these with the
// certificates and Business Manager, so every public page reads them from here and never retypes them.
export const COMPANY = {
  brand: "Sendtoo",
  legalName: "Capexlite Logistics Solutions Private Limited",
  brandLine: "Sendtoo is a brand of Capexlite Logistics Solutions Private Limited",
  cin: "U53200AP2026PTC123946",
  gstin: "37AANCC5387L1ZV",
  // Write this EXACTLY as printed on the GST / incorporation certificate.
  addressLines: ["D No. 50-81-24/12, GVK Plaza", "Seethammapeta Main Road", "Visakhapatnam - 530016", "Andhra Pradesh, India"],
  phone: "+91 89193 40840",          // call number (also the Meta Business verification phone)
  phoneTel: "+918919340840",
  // WhatsApp Business API number: chats land in the CRM (crm.sendtoo.in), where the chatbot greets and records leads.
  whatsapp: "918985503616",
  whatsappDisplay: "+91 89855 03616",
  email: "support@sendtoo.in",
  website: "https://www.sendtoo.in",
};
COMPANY.addressOneLine = COMPANY.addressLines.join(", ");

// Chat link to the WhatsApp API number with a pre-filled first message (the customer only taps Send).
export const whatsappLink = (text = "Hi Sendtoo") => `https://wa.me/${COMPANY.whatsapp}?text=${encodeURIComponent(text)}`;

// Grievance Officer (DPDP Act 2023 / IT Rules 2011). Confirm the person before going live.
export const GRIEVANCE = {
  name: "Aditya Prasad Mutnuru",
  designation: "Director & Grievance Officer",
  email: "support@sendtoo.in",
  responseNote: "We acknowledge grievances within 48 hours and aim to resolve them within 15 days.",
};

// Policy figures: confirm each against how you actually operate before going live.
export const POLICY = {
  effectiveDate: "19 October 2026",
  refundDays: "7 working days",
  claimDays: "3 days",
  retentionMarketing: "until you withdraw consent",
  retentionAccount: "while your account is active and for as long as the law requires us to keep tax, accounting and shipment records afterwards",
};

// Exact WhatsApp opt-in wording. The text shown is saved with each tick, so change the version when the wording changes.
export const WHATSAPP_OPTIN = {
  version: "v1-2026-10",
  text: "I agree to receive updates and offers from Sendtoo on WhatsApp. Reply STOP to opt out.",
};
